module.exports = __webpack_public_path__ + "static/media/Torso_1.26ac815c.jpg";